import React from 'react';
import { Link } from 'react-router-dom';

import { safeContent, isIEBrowser } from '../../utils';

export default function IntroSlide( props ) {

    const slide = props.slide;
 
    return (
        <div className="intro-slide">
           <figure className="slide-image">
                <picture style={ isIEBrowser() ? { height: '100%' } : {} }>
                    <source media="(max-width: 480px)" srcSet={ `${process.env.REACT_APP_API_URL}/uploads/banners/${slide.fileName}` } />
                    <img src={ `${process.env.REACT_APP_API_URL}/uploads/banners/${slide.fileName}` } alt="desc" style={ isIEBrowser() ? { width: 'auto', height: '100%', maxWidth: '100%' } : {} } width="1180" height="500" />
                </picture>
            </figure>

            {/*<img src={ `${process.env.REACT_APP_API_URL}/uploads/banners/${slide.fileName}` } alt=" " width="1180" height="500" />*/}

            <div className="intro-content">
                {/*<h3 className="intro-subtitle">{ title }</h3>*/}
                <h1 className="intro-title text-white" dangerouslySetInnerHTML={ safeContent( slide.titleFr ) }></h1>

                {
                    slide.subTitleFr ?
                        <div className="intro-text text-white" dangerouslySetInnerHTML={ safeContent( slide.subTitleFr ) }>
                        </div>
                        : ""
                }

                {/*
                    price ?
                        <div className="intro-price text-white" dangerouslySetInnerHTML={ safeContent( slide ) }>
                        </div>
                        : ""
                */}

                {/*<Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/sidebar/list` } className="btn btn-primary">
                    <span>DISCOVER NOW</span>
                    <i className="icon-long-arrow-right"></i>
                </Link>*/}

                <a href={ slide.linkUrl } target="_blank" className="btn btn-primary">
                    <span>{ slide.linkTextFr }</span>
                    <i className="icon-long-arrow-right"></i>
                </a>
            </div>
        </div>
    )
}